import React from 'react'
import { TabPaneProps, Tabs } from 'antd'

const { TabPane } = Tabs

export const CustomTabPane: React.FC<TabPaneProps & { divStyle?: React.CSSProperties }> = (
  props
) => {
  return (
    <TabPane {...props}>
      <div style={props.divStyle}>
        <div className={'request-tab-content-section'}>{props.children}</div>
      </div>
    </TabPane>
  )
}
